import React, { useState } from "react";

export const useZoom = () => {
  // 当前缩放的级别;
  const [zoomLive, setZoomLive] = useState(0);
  // 最大缩放级别
  const [maxZoomLive, setMaxZoomLive] = useState(2); 
  
  return { zoomLive, maxZoomLive, setZoomLive, setMaxZoomLive }
}